import { jsx as _jsx } from "react/jsx-runtime";
import { useMap } from "react-map-gl/mapbox";
import { Box } from "@gemini/core";
import { MinusIcon, PlusIcon } from "@gemini/icons";
import { FloatingButtonGroup } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
export const MapZoom = () => {
    const { current: map } = useMap();
    const { t } = useI18n();
    const handleZoomIn = () => map === null || map === void 0 ? void 0 : map.zoomIn();
    const handleZoomOut = () => map === null || map === void 0 ? void 0 : map.zoomOut();
    const zoomItems = [
        {
            children: t("location.map.modal.controls.zoom_in"),
            icon: PlusIcon,
            id: "zoom-in",
            onPress: handleZoomIn,
        },
        {
            children: t("location.map.modal.controls.zoom_out"),
            icon: MinusIcon,
            id: "zoom-out",
            onPress: handleZoomOut,
        },
    ];
    return (_jsx(Box, { display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "inherit",
        }, children: _jsx(FloatingButtonGroup, { items: zoomItems }) }));
};
